import React from 'react';
import Layout from '../components/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { Mail, Calendar, BookOpen, MessageCircle } from 'lucide-react';

export default function Support() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-heading font-bold mb-2">Support</h1>
          <p className="text-muted-foreground">We're here to help you succeed</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <BookOpen className="w-12 h-12 text-primary mb-4" />
              <CardTitle>Knowledge Base</CardTitle>
              <CardDescription>
                Browse our comprehensive guides and tutorials to find answers to common questions
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/knowledge-base">
                <Button className="w-full" data-testid="kb-link">
                  Browse Articles
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <Mail className="w-12 h-12 text-primary mb-4" />
              <CardTitle>Email Support</CardTitle>
              <CardDescription>
                Send us an email and we'll get back to you within 24 hours
              </CardDescription>
            </CardHeader>
            <CardContent>
              <a href="mailto:support@edrano.my">
                <Button className="w-full" data-testid="email-support">
                  Email Us
                </Button>
              </a>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <Calendar className="w-12 h-12 text-primary mb-4" />
              <CardTitle>Schedule a Call</CardTitle>
              <CardDescription>
                Book a consultation with our team to discuss your needs
              </CardDescription>
            </CardHeader>
            <CardContent>
              <a href="https://calendly.com/edrano" target="_blank" rel="noopener noreferrer">
                <Button variant="outline" className="w-full" data-testid="schedule-call">
                  Book Appointment
                </Button>
              </a>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <MessageCircle className="w-12 h-12 text-primary mb-4" />
              <CardTitle>Service Issues</CardTitle>
              <CardDescription>
                Having trouble with your services? Check your services page or contact us
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/my-services">
                <Button variant="outline" className="w-full">
                  View My Services
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Contact Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <h3 className="font-semibold mb-1">Email</h3>
              <a href="mailto:support@edrano.my" className="text-primary hover:underline">
                support@edrano.my
              </a>
            </div>
            <div>
              <h3 className="font-semibold mb-1">Website</h3>
              <a href="https://support.edrano.my" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                support.edrano.my
              </a>
            </div>
            <div>
              <h3 className="font-semibold mb-1">Business Hours</h3>
              <p className="text-muted-foreground">Monday - Friday: 9:00 AM - 6:00 PM (EET)</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}